/**
 * Default form values for a NEW record: the platform schema defaults
 * (`defaultSchemaValues`, from the backend field schema), overridden by the
 * resource config's `formDTO.newRecordDefaults` (a UI default that deliberately
 * differs from the backend default), overridden by explicit caller defaults.
 *
 * Example: object_template_attribute.is_nullable has backend default `false`,
 * but the editor starts a new attribute as not required (`is_nullable: true`).
 */
export const mergeNewRecordDefaults = (
    defaultSchemaValues: Record<string, unknown> | undefined,
    configNewRecordDefaults: Record<string, unknown> | undefined,
    callerDefaults: Record<string, unknown> | undefined
): Record<string, unknown> => ({
    ...(defaultSchemaValues || {}),
    ...(configNewRecordDefaults || {}),
    ...(callerDefaults || {}),
});
